export default "__VITE_ASSET__1LKBNm4l__"